import routerOptions0 from "/home/runner/work/dashboard/dashboard/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@25.0.0_@vue+compiler-sfc@3.5.25_cac@6.7.1_595b8f28fae60f73359915e863793472/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}